import { useEffect } from 'react';

export default function UserWayWidget() {
  useEffect(() => {
    const existing = document.querySelector('script[src="https://cdn.userway.org/widget.js"]');
    if (!existing) {
      const script = document.createElement('script');
      script.src = 'https://cdn.userway.org/widget.js';
      script.setAttribute('data-account', 'ljTzyqM2Vd'); // Replace with your ID
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
}